import React, { useEffect, useState } from 'react';
import styles from './RedeemSTF.module.scss';
import Header from '../../components/Header/Header';
import addCommas from "../../utils/amountFormat";
import validator from "../../utils/validator";
import useRedeemStf from '../../hooks/useRedeemStf';
import { useLocation, useNavigate } from 'react-router-dom';
import analyticsService from '../../services/analytics/analyticsService';




function RedeemStf(props:any) {
  const [status, setStatus] = useState<number>(200);
  const [redeemAmt, setRedeemAmt] = useState({
    value: "",
    error: "",
    touched: false,
  });

  const [redeemStf] = useRedeemStf();
  const navigate = useNavigate();
  const location = useLocation();

  const school = location.state.school;
  const stfSales = location.state.stfFunds;
  let dumble = new analyticsService();


  const handleInput = (type: string, input: any, field: object) => {
    const newField: any = { ...field };
    newField[type] = input;
    return newField;
  };

  const enoughFunds = () => {
    if (parseFloat(redeemAmt.value.replaceAll(",", "")) > stfSales) {
      setRedeemAmt(handleInput("error", "Not enough funds", redeemAmt));
    } 
  };

  useEffect(() => {
    setRedeemAmt(
      handleInput(
        "error",
        validator(redeemAmt.value, ["required"]),
        redeemAmt
      )
    );
    enoughFunds();
  }, [redeemAmt.value])


    

  const handleRedeem = async () => {
    setRedeemAmt(handleInput("touched", true, redeemAmt));
    const payload = {
      amount: redeemAmt.value,
    }
    const { data, error } = await redeemStf(payload);
    if (error){
      console.log(error);
      return;
    } else if (data != null) {
      navigate("/success", { state: { toasterType: "stf" } });
    }

  }

  const displayError = (input: any) => {
    if (input.error !== "") {
      return <div className={styles.errorMessage}>{input.error}</div>;
    }
    return null;
  };


  return(
    <div className={styles.RedeemStf} data-testid="RedeemStf">
      <Header name="Input Redemption Amount" redirect="/" />
      <div className={styles.StfWrapper}>
        <div className={styles.responsive}>
            <div className={styles.info}>
              {school}
              <br/>
              Share the Fair funds
              <br/>
              <h3>${stfSales}</h3>
            </div>
            <label htmlFor="paymentAmt" className={styles.payAmt}>
              Payment Amount
              <input
                type="text"
                value={`$ ${redeemAmt.value}`}
                maxLength={10}
                onChange={(e) =>
                  setRedeemAmt(
                    handleInput(
                      "value",
                      addCommas(e.target.value),
                      redeemAmt
                    )
                  )
                }
                onBlur={() => setRedeemAmt(handleInput("touched", true, redeemAmt))}
                aria-label="paymentAmt"
                id="paymentAmt"
              />
              {redeemAmt.error !== "" && redeemAmt.touched ? displayError(redeemAmt) : null}
              {redeemAmt.error === "" && status !== 200 ? (
                <div className={styles.errorMessage}>
                  Service is down. Please try again later.
                </div>
              ) : null}
            </label>
          </div>
          <button
            type="submit"
            onClick={handleRedeem}
            id="submitButton"
            disabled={false}
          >
            SUBMIT PAYMENT
          </button>
        </div>
      </div>
  )

};

export default RedeemStf;
